import {Form} from 'antd'
import meta from './metaAm.mjs'
import Select from './SelectAm.jsx'

export const FormItemAm = props => (
    <Form.Item
        label={meta.name}
        name="am"
        {...props}
    >
        <Select />
    </Form.Item>
)

export const FormItemAms = props => (
    <Form.Item
        label={meta.name}
        name="ams"
        {...props}
    >
        <Select multiple />
    </Form.Item>
)
